export default [
    {text:"中国-安徽省-合肥市",value:35434},
    {text:"中国-安徽省-芜湖市",value:35435},
    {text:"中国-安徽省-蚌埠市",value:35436},
    {text:"中国-安徽省-淮南市",value:35437},
    {text:"中国-安徽省-马鞍山市",value:35438},
    {text:"中国-安徽省-淮北市",value:35439},
    {text:"中国-安徽省-铜陵市",value:35440},
    {text:"中国-安徽省-安庆市",value:35441},
    {text:"中国-安徽省-黄山市",value:35442},
    {text:"中国-安徽省-滁州市",value:35443},
    {text:"中国-安徽省-阜阳市",value:35444},
    {text:"中国-安徽省-宿州市",value:35445},
    {text:"中国-安徽省-六安市",value:35446},
    {text:"中国-安徽省-亳州市",value:35447},
    {text:"中国-安徽省-池州市",value:35448},
    {text:"中国-安徽省-宣城市",value:35449},
    {text:"中国-安徽省-巢湖市",value:35450},
    {text:"中国-北京市-东城区",value:35451},
    {text:"中国-北京市-西城区",value:35452},
    {text:"中国-北京市-朝阳区",value:35453},
    {text:"中国-北京市-丰台区",value:35454},
    {text:"中国-北京市-石景山区",value:35455},
    {text:"中国-北京市-海淀区",value:35456},
    {text:"中国-北京市-门头沟区",value:35457},
    {text:"中国-北京市-房山区",value:35458},
    {text:"中国-北京市-通州区",value:35459},
    {text:"中国-北京市-顺义区",value:35460},
    {text:"中国-北京市-昌平区",value:35461},
    {text:"中国-北京市-大兴区",value:35462},
    {text:"中国-北京市-怀柔区",value:35463},
    {text:"中国-北京市-平谷区",value:35464},
    {text:"中国-北京市-密云县",value:35465},
    {text:"中国-北京市-延庆县",value:35466},
    {text:"中国-北京市-宣武区",value:35467},
    {text:"中国-北京市-崇文区",value:35468},
    {text:"中国-福建省-福州市",value:35469},
    {text:"中国-福建省-厦门市",value:35470},
    {text:"中国-福建省-莆田市",value:35471},
    {text:"中国-福建省-三明市",value:35472},
    {text:"中国-福建省-泉州市",value:35473},
    {text:"中国-福建省-漳州市",value:35474},
    {text:"中国-福建省-南平市",value:35475},
    {text:"中国-福建省-龙岩市",value:35476},
    {text:"中国-福建省-宁德市",value:35477},
    {text:"中国-甘肃省-兰州市",value:35478},
    {text:"中国-甘肃省-嘉峪关市",value:35479},
    {text:"中国-甘肃省-金昌市",value:35480},
    {text:"中国-甘肃省-白银市",value:35481},
    {text:"中国-甘肃省-天水市",value:35482},
    {text:"中国-甘肃省-武威市",value:35483},
    {text:"中国-甘肃省-张掖市",value:35484},
    {text:"中国-甘肃省-平凉市",value:35485},
    {text:"中国-甘肃省-酒泉市",value:35486},
    {text:"中国-甘肃省-庆阳市",value:35487},
    {text:"中国-甘肃省-定西市",value:35488},
    {text:"中国-甘肃省-陇南市",value:35489},
    {text:"中国-甘肃省-临夏回族自治州",value:35490},
    {text:"中国-甘肃省-甘南藏族自治州",value:35491},
    {text:"中国-广东省-广州市",value:35492},
    {text:"中国-广东省-韶关市",value:35493},
    {text:"中国-广东省-深圳市",value:35494},
    {text:"中国-广东省-珠海市",value:35495},
    {text:"中国-广东省-汕头市",value:35496},
    {text:"中国-广东省-佛山市",value:35497},
    {text:"中国-广东省-江门市",value:35498},
    {text:"中国-广东省-湛江市",value:35499},
    {text:"中国-广东省-茂名市",value:35500},
    {text:"中国-广东省-肇庆市",value:35501},
    {text:"中国-广东省-惠州市",value:35502},
    {text:"中国-广东省-梅州市",value:35503},
    {text:"中国-广东省-汕尾市",value:35504},
    {text:"中国-广东省-河源市",value:35505},
    {text:"中国-广东省-阳江市",value:35506},
    {text:"中国-广东省-清远市",value:35507},
    {text:"中国-广东省-东莞市",value:35508},
    {text:"中国-广东省-中山市",value:35509},
    {text:"中国-广东省-潮州市",value:35510},
    {text:"中国-广东省-揭阳市",value:35511},
    {text:"中国-广东省-云浮市",value:35512},
    {text:"中国-广西省-南宁市",value:35513},
    {text:"中国-广西省-柳州市",value:35514},
    {text:"中国-广西省-桂林市",value:35515},
    {text:"中国-广西省-梧州市",value:35516},
    {text:"中国-广西省-北海市",value:35517},
    {text:"中国-广西省-防城港市",value:35518},
    {text:"中国-广西省-钦州市",value:35519},
    {text:"中国-广西省-贵港市",value:35520},
    {text:"中国-广西省-玉林市",value:35521},
    {text:"中国-广西省-百色市",value:35522},
    {text:"中国-广西省-贺州市",value:35523},
    {text:"中国-广西省-河池市",value:35524},
    {text:"中国-广西省-来宾市",value:35525},
    {text:"中国-广西省-崇左市",value:35526},
    {text:"中国-贵州省-贵阳市",value:35527},
    {text:"中国-贵州省-六盘水市",value:35528},
    {text:"中国-贵州省-遵义市",value:35529},
    {text:"中国-贵州省-安顺市",value:35530},
    {text:"中国-贵州省-毕节市",value:35531},
    {text:"中国-贵州省-铜仁市",value:35532},
    {text:"中国-贵州省-黔西南布依族苗族自治州",value:35533},
    {text:"中国-贵州省-黔东南苗族侗族自治州",value:35534},
    {text:"中国-贵州省-黔南布依族苗族自治州",value:35535},
    {text:"中国-海南省-海口市",value:35536},
    {text:"中国-海南省-三亚市",value:35537},
    {text:"中国-海南省-三沙市",value:35538},
    {text:"中国-海南省-琼海市",value:35539},
    {text:"中国-海南省-文昌市",value:35540},
    {text:"中国-海南省-东方市",value:35541},
    {text:"中国-海南省-昌江县",value:35542},
    {text:"中国-海南省-陵水县",value:35543},
    {text:"中国-海南省-乐东县",value:35544},
    {text:"中国-海南省-保亭县",value:35545},
    {text:"中国-海南省-五指山市",value:35546},
    {text:"中国-海南省-澄迈县",value:35547},
    {text:"中国-海南省-万宁市",value:35548},
    {text:"中国-海南省-儋州市",value:35549},
    {text:"中国-海南省-临高县",value:35550},
    {text:"中国-海南省-白沙县",value:35551},
    {text:"中国-海南省-定安县",value:35552},
    {text:"中国-海南省-琼中县",value:35553},
    {text:"中国-海南省-屯昌县",value:35554},
    {text:"中国-海南省-省直辖县级行政区划",value:35555},
    {text:"中国-河北省-石家庄市",value:35556},
    {text:"中国-河北省-唐山市",value:35557},
    {text:"中国-河北省-秦皇岛市",value:35558},
    {text:"中国-河北省-邯郸市",value:35559},
    {text:"中国-河北省-邢台市",value:35560},
    {text:"中国-河北省-保定市",value:35561},
    {text:"中国-河北省-张家口市",value:35562},
    {text:"中国-河北省-承德市",value:35563},
    {text:"中国-河北省-沧州市",value:35564},
    {text:"中国-河北省-廊坊市",value:35565},
    {text:"中国-河北省-衡水市",value:35566},
    {text:"中国-河北省-河北区",value:35567},
    {text:"中国-河南省-郑州市",value:35568},
    {text:"中国-河南省-开封市",value:35569},
    {text:"中国-河南省-洛阳市",value:35570},
    {text:"中国-河南省-平顶山市",value:35571},
    {text:"中国-河南省-安阳市",value:35572},
    {text:"中国-河南省-鹤壁市",value:35573},
    {text:"中国-河南省-新乡市",value:35574},
    {text:"中国-河南省-焦作市",value:35575},
    {text:"中国-河南省-濮阳市",value:35576},
    {text:"中国-河南省-许昌市",value:35577},
    {text:"中国-河南省-漯河市",value:35578},
    {text:"中国-河南省-三门峡市",value:35579},
    {text:"中国-河南省-南阳市",value:35580},
    {text:"中国-河南省-商丘市",value:35581},
    {text:"中国-河南省-信阳市",value:35582},
    {text:"中国-河南省-周口市",value:35583},
    {text:"中国-河南省-驻马店市",value:35584},
    {text:"中国-河南省-济源市",value:35585},
    {text:"中国-黑龙江省-哈尔滨市",value:35586},
    {text:"中国-黑龙江省-齐齐哈尔市",value:35587},
    {text:"中国-黑龙江省-鸡西市",value:35588},
    {text:"中国-黑龙江省-鹤岗市",value:35589},
    {text:"中国-黑龙江省-双鸭山市",value:35590},
    {text:"中国-黑龙江省-大庆市",value:35591},
    {text:"中国-黑龙江省-伊春市",value:35592},
    {text:"中国-黑龙江省-佳木斯市",value:35593},
    {text:"中国-黑龙江省-七台河市",value:35594},
    {text:"中国-黑龙江省-牡丹江市",value:35595},
    {text:"中国-黑龙江省-黑河市",value:35596},
    {text:"中国-黑龙江省-绥化市",value:35597},
    {text:"中国-黑龙江省-大兴安岭地区",value:35598},
    {text:"中国-湖北省-武汉市",value:35599},
    {text:"中国-湖北省-黄石市",value:35600},
    {text:"中国-湖北省-十堰市",value:35601},
    {text:"中国-湖北省-宜昌市",value:35602},
    {text:"中国-湖北省-襄阳市",value:35603},
    {text:"中国-湖北省-鄂州市",value:35604},
    {text:"中国-湖北省-荆门市",value:35605},
    {text:"中国-湖北省-孝感市",value:35606},
    {text:"中国-湖北省-荆州市",value:35607},
    {text:"中国-湖北省-黄冈市",value:35608},
    {text:"中国-湖北省-咸宁市",value:35609},
    {text:"中国-湖北省-随州市",value:35610},
    {text:"中国-湖北省-恩施土家族苗族自治州",value:35611},
    {text:"中国-湖北省-襄樊市",value:35612},
    {text:"中国-湖北省-仙桃市",value:35613},
    {text:"中国-湖北省-天门市",value:35614},
    {text:"中国-湖北省-潜江市",value:35615},
    {text:"中国-湖北省-神农架林区",value:35616},
    {text:"中国-湖北省-省直辖县级行政区划",value:35617},
    {text:"中国-湖南省-长沙市",value:35618},
    {text:"中国-湖南省-株洲市",value:35619},
    {text:"中国-湖南省-湘潭市",value:35620},
    {text:"中国-湖南省-衡阳市",value:35621},
    {text:"中国-湖南省-邵阳市",value:35622},
    {text:"中国-湖南省-岳阳市",value:35623},
    {text:"中国-湖南省-常德市",value:35624},
    {text:"中国-湖南省-张家界市",value:35625},
    {text:"中国-湖南省-益阳市",value:35626},
    {text:"中国-湖南省-郴州市",value:35627},
    {text:"中国-湖南省-永州市",value:35628},
    {text:"中国-湖南省-怀化市",value:35629},
    {text:"中国-湖南省-娄底市",value:35630},
    {text:"中国-湖南省-湘西土家族苗族自治州",value:35631},
    {text:"中国-吉林省-长春市",value:35632},
    {text:"中国-吉林省-吉林市",value:35633},
    {text:"中国-吉林省-四平市",value:35634},
    {text:"中国-吉林省-辽源市",value:35635},
    {text:"中国-吉林省-通化市",value:35636},
    {text:"中国-吉林省-白山市",value:35637},
    {text:"中国-吉林省-松原市",value:35638},
    {text:"中国-吉林省-白城市",value:35639},
    {text:"中国-吉林省-延边朝鲜族自治州",value:35640},
    {text:"中国-江苏省-南京市",value:35641},
    {text:"中国-江苏省-无锡市",value:35642},
    {text:"中国-江苏省-徐州市",value:35643},
    {text:"中国-江苏省-常州市",value:35644},
    {text:"中国-江苏省-苏州市",value:35645},
    {text:"中国-江苏省-南通市",value:35646},
    {text:"中国-江苏省-连云港市",value:35647},
    {text:"中国-江苏省-淮安市",value:35648},
    {text:"中国-江苏省-盐城市",value:35649},
    {text:"中国-江苏省-扬州市",value:35650},
    {text:"中国-江苏省-镇江市",value:35651},
    {text:"中国-江苏省-泰州市",value:35652},
    {text:"中国-江苏省-宿迁市",value:35653},
    {text:"中国-江西省-南昌市",value:35654},
    {text:"中国-江西省-景德镇市",value:35655},
    {text:"中国-江西省-萍乡市",value:35656},
    {text:"中国-江西省-九江市",value:35657},
    {text:"中国-江西省-新余市",value:35658},
    {text:"中国-江西省-鹰潭市",value:35659},
    {text:"中国-江西省-赣州市",value:35660},
    {text:"中国-江西省-吉安市",value:35661},
    {text:"中国-江西省-宜春市",value:35662},
    {text:"中国-江西省-抚州市",value:35663},
    {text:"中国-江西省-上饶市",value:35664},
    {text:"中国-辽宁省-沈阳市",value:35665},
    {text:"中国-辽宁省-大连市",value:35666},
    {text:"中国-辽宁省-鞍山市",value:35667},
    {text:"中国-辽宁省-抚顺市",value:35668},
    {text:"中国-辽宁省-本溪市",value:35669},
    {text:"中国-辽宁省-丹东市",value:35670},
    {text:"中国-辽宁省-锦州市",value:35671},
    {text:"中国-辽宁省-营口市",value:35672},
    {text:"中国-辽宁省-阜新市",value:35673},
    {text:"中国-辽宁省-辽阳市",value:35674},
    {text:"中国-辽宁省-盘锦市",value:35675},
    {text:"中国-辽宁省-铁岭市",value:35676},
    {text:"中国-辽宁省-朝阳市",value:35677},
    {text:"中国-辽宁省-葫芦岛市",value:35678},
    {text:"中国-内蒙古自治区-呼和浩特市",value:35679},
    {text:"中国-内蒙古自治区-包头市",value:35680},
    {text:"中国-内蒙古自治区-乌海市",value:35681},
    {text:"中国-内蒙古自治区-赤峰市",value:35682},
    {text:"中国-内蒙古自治区-通辽市",value:35683},
    {text:"中国-内蒙古自治区-鄂尔多斯市",value:35684},
    {text:"中国-内蒙古自治区-呼伦贝尔市",value:35685},
    {text:"中国-内蒙古自治区-巴彦淖尔市",value:35686},
    {text:"中国-内蒙古自治区-乌兰察布市",value:35687},
    {text:"中国-内蒙古自治区-兴安盟",value:35688},
    {text:"中国-内蒙古自治区-锡林郭勒盟",value:35689},
    {text:"中国-内蒙古自治区-阿拉善盟",value:35690},
    {text:"中国-宁夏省-银川市",value:35691},
    {text:"中国-宁夏省-石嘴山市",value:35692},
    {text:"中国-宁夏省-吴忠市",value:35693},
    {text:"中国-宁夏省-固原市",value:35694},
    {text:"中国-宁夏省-中卫市",value:35695},
    {text:"中国-青海省-西宁市",value:35696},
    {text:"中国-青海省-海东地区",value:35697},
    {text:"中国-青海省-海北藏族自治州",value:35698},
    {text:"中国-青海省-黄南藏族自治州",value:35699},
    {text:"中国-青海省-海南藏族自治州",value:35700},
    {text:"中国-青海省-果洛藏族自治州",value:35701},
    {text:"中国-青海省-玉树藏族自治州",value:35702},
    {text:"中国-青海省-海西蒙古族藏族自治州",value:35703},
    {text:"中国-山东省-济南市",value:35704},
    {text:"中国-山东省-青岛市",value:35705},
    {text:"中国-山东省-淄博市",value:35706},
    {text:"中国-山东省-枣庄市",value:35707},
    {text:"中国-山东省-东营市",value:35708},
    {text:"中国-山东省-烟台市",value:35709},
    {text:"中国-山东省-潍坊市",value:35710},
    {text:"中国-山东省-济宁市",value:35711},
    {text:"中国-山东省-泰安市",value:35712},
    {text:"中国-山东省-威海市",value:35713},
    {text:"中国-山东省-日照市",value:35714},
    {text:"中国-山东省-莱芜市",value:35715},
    {text:"中国-山东省-临沂市",value:35716},
    {text:"中国-山东省-德州市",value:35717},
    {text:"中国-山东省-聊城市",value:35718},
    {text:"中国-山东省-滨州市",value:35719},
    {text:"中国-山东省-菏泽市",value:35720},
    {text:"中国-山西省-太原市",value:35721},
    {text:"中国-山西省-大同市",value:35722},
    {text:"中国-山西省-阳泉市",value:35723},
    {text:"中国-山西省-长治市",value:35724},
    {text:"中国-山西省-晋城市",value:35725},
    {text:"中国-山西省-朔州市",value:35726},
    {text:"中国-山西省-晋中市",value:35727},
    {text:"中国-山西省-运城市",value:35728},
    {text:"中国-山西省-忻州市",value:35729},
    {text:"中国-山西省-临汾市",value:35730},
    {text:"中国-山西省-吕梁市",value:35731},
    {text:"中国-山西省-西安市",value:35732},
    {text:"中国-山西省-铜川市",value:35733},
    {text:"中国-山西省-宝鸡市",value:35734},
    {text:"中国-山西省-咸阳市",value:35735},
    {text:"中国-山西省-渭南市",value:35736},
    {text:"中国-山西省-延安市",value:35737},
    {text:"中国-山西省-汉中市",value:35738},
    {text:"中国-山西省-榆林市",value:35739},
    {text:"中国-山西省-安康市",value:35740},
    {text:"中国-山西省-商洛市",value:35741},
    {text:"中国-上海市-黄浦区",value:35742},
    {text:"中国-上海市-徐汇区",value:35743},
    {text:"中国-上海市-长宁区",value:35744},
    {text:"中国-上海市-静安区",value:35745},
    {text:"中国-上海市-普陀区",value:35746},
    {text:"中国-上海市-闸北区",value:35747},
    {text:"中国-上海市-虹口区",value:35748},
    {text:"中国-上海市-杨浦区",value:35749},
    {text:"中国-上海市-闵行区",value:35750},
    {text:"中国-上海市-宝山区",value:35751},
    {text:"中国-上海市-嘉定区",value:35752},
    {text:"中国-上海市-浦东新区",value:35753},
    {text:"中国-上海市-金山区",value:35754},
    {text:"中国-上海市-松江区",value:35755},
    {text:"中国-上海市-青浦区",value:35756},
    {text:"中国-上海市-奉贤区",value:35757},
    {text:"中国-上海市-崇明县",value:35758},
    {text:"中国-四川省-成都市",value:35759},
    {text:"中国-四川省-自贡市",value:35760},
    {text:"中国-四川省-攀枝花市",value:35761},
    {text:"中国-四川省-泸州市",value:35762},
    {text:"中国-四川省-德阳市",value:35763},
    {text:"中国-四川省-绵阳市",value:35764},
    {text:"中国-四川省-广元市",value:35765},
    {text:"中国-四川省-遂宁市",value:35766},
    {text:"中国-四川省-内江市",value:35767},
    {text:"中国-四川省-乐山市",value:35768},
    {text:"中国-四川省-南充市",value:35769},
    {text:"中国-四川省-眉山市",value:35770},
    {text:"中国-四川省-宜宾市",value:35771},
    {text:"中国-四川省-广安市",value:35772},
    {text:"中国-四川省-达州市",value:35773},
    {text:"中国-四川省-雅安市",value:35774},
    {text:"中国-四川省-巴中市",value:35775},
    {text:"中国-四川省-资阳市",value:35776},
    {text:"中国-四川省-阿坝藏族羌族自治州",value:35777},
    {text:"中国-四川省-甘孜藏族自治州",value:35778},
    {text:"中国-四川省-凉山彝族自治州",value:35779},
    {text:"中国-台湾省-台北市",value:35780},
    {text:"中国-台湾省-高雄市 ",value:35781},
    {text:"中国-台湾省-台中市",value:35782},
    {text:"中国-台湾省-新竹市",value:35783},
    {text:"中国-台湾省-基隆市",value:35784},
    {text:"中国-台湾省-台南市",value:35785},
    {text:"中国-台湾省-嘉义市",value:35786},
    {text:"中国-天津市-和平区",value:35787},
    {text:"中国-天津市-河东区",value:35788},
    {text:"中国-天津市-河西区",value:35789},
    {text:"中国-天津市-南开区",value:35790},
    {text:"中国-天津市-河北区",value:35791},
    {text:"中国-天津市-红桥区",value:35792},
    {text:"中国-天津市-东丽区",value:35793},
    {text:"中国-天津市-西青区",value:35794},
    {text:"中国-天津市-津南区",value:35795},
    {text:"中国-天津市-北辰区",value:35796},
    {text:"中国-天津市-武清区",value:35797},
    {text:"中国-天津市-宝坻区",value:35798},
    {text:"中国-天津市-滨海新区",value:35799},
    {text:"中国-天津市-宁河县",value:35800},
    {text:"中国-天津市-静海县",value:35801},
    {text:"中国-天津市-蓟县",value:35802},
    {text:"中国-天津市-大港区",value:35803},
    {text:"中国-天津市-汉沽区",value:35804},
    {text:"中国-天津市-塘沽区",value:35805},
    {text:"中国-西藏省-拉萨市",value:35806},
    {text:"中国-西藏省-昌都地区",value:35807},
    {text:"中国-西藏省-山南地区",value:35808},
    {text:"中国-西藏省-日喀则地区",value:35809},
    {text:"中国-西藏省-那曲地区",value:35810},
    {text:"中国-西藏省-阿里地区",value:35811},
    {text:"中国-西藏省-林芝地区",value:35812},
    {text:"中国-新疆省-乌鲁木齐市",value:35813},
    {text:"中国-新疆省-克拉玛依市",value:35814},
    {text:"中国-新疆省-吐鲁番地区",value:35815},
    {text:"中国-新疆省-哈密地区",value:35816},
    {text:"中国-新疆省-昌吉回族自治州",value:35817},
    {text:"中国-新疆省-博尔塔拉蒙古自治州",value:35818},
    {text:"中国-新疆省-巴音郭楞蒙古自治州",value:35819},
    {text:"中国-新疆省-阿克苏地区",value:35820},
    {text:"中国-新疆省-克孜勒苏柯尔克孜自治州",value:35821},
    {text:"中国-新疆省-喀什地区",value:35822},
    {text:"中国-新疆省-和田地区",value:35823},
    {text:"中国-新疆省-伊犁哈萨克自治州",value:35824},
    {text:"中国-新疆省-塔城地区",value:35825},
    {text:"中国-新疆省-阿勒泰地区",value:35826},
    {text:"中国-新疆省-石河子市",value:35827},
    {text:"中国-新疆省-阿拉尔市",value:35828},
    {text:"中国-新疆省-五家渠市",value:35829},
    {text:"中国-新疆省-图木舒克市",value:35830},
    {text:"中国-新疆省-自治区直辖县级行政区划",value:35831},
    {text:"中国-云南省-昆明市",value:35832},
    {text:"中国-云南省-曲靖市",value:35833},
    {text:"中国-云南省-玉溪市",value:35834},
    {text:"中国-云南省-保山市",value:35835},
    {text:"中国-云南省-昭通市",value:35836},
    {text:"中国-云南省-丽江市",value:35837},
    {text:"中国-云南省-普洱市",value:35838},
    {text:"中国-云南省-临沧市",value:35839},
    {text:"中国-云南省-楚雄彝族自治州",value:35840},
    {text:"中国-云南省-红河哈尼族彝族自治州",value:35841},
    {text:"中国-云南省-文山壮族苗族自治州",value:35842},
    {text:"中国-云南省-西双版纳傣族自治州",value:35843},
    {text:"中国-云南省-大理白族自治州",value:35844},
    {text:"中国-云南省-德宏傣族景颇族自治州",value:35845},
    {text:"中国-云南省-怒江傈僳族自治州",value:35846},
    {text:"中国-云南省-迪庆藏族自治州",value:35847},
    {text:"中国-云南省-思茅地区",value:35848},
    {text:"中国-浙江省-杭州市",value:35849},
    {text:"中国-浙江省-宁波市",value:35850},
    {text:"中国-浙江省-温州市",value:35851},
    {text:"中国-浙江省-嘉兴市",value:35852},
    {text:"中国-浙江省-湖州市",value:35853},
    {text:"中国-浙江省-绍兴市",value:35854},
    {text:"中国-浙江省-金华市",value:35855},
    {text:"中国-浙江省-衢州市",value:35856},
    {text:"中国-浙江省-舟山市",value:35857},
    {text:"中国-浙江省-台州市",value:35858},
    {text:"中国-浙江省-丽水市",value:35859},
    {text:"中国-重庆市-万州区",value:35860},
    {text:"中国-重庆市-涪陵区",value:35861},
    {text:"中国-重庆市-渝中区",value:35862},
    {text:"中国-重庆市-大渡口区",value:35863},
    {text:"中国-重庆市-江北区",value:35864},
    {text:"中国-重庆市-沙坪坝区",value:35865},
    {text:"中国-重庆市-九龙坡区",value:35866},
    {text:"中国-重庆市-南岸区",value:35867},
    {text:"中国-重庆市-北碚区",value:35868},
    {text:"中国-重庆市-綦江区",value:35869},
    {text:"中国-重庆市-大足区",value:35870},
    {text:"中国-重庆市-渝北区",value:35871},
    {text:"中国-重庆市-巴南区",value:35872},
    {text:"中国-重庆市-黔江区",value:35873},
    {text:"中国-重庆市-长寿区",value:35874},
    {text:"中国-重庆市-江津区",value:35875},
    {text:"中国-重庆市-合川区",value:35876},
    {text:"中国-重庆市-永川区",value:35877},
    {text:"中国-重庆市-南川区",value:35878},
    {text:"中国-重庆市-潼南县",value:35879},
    {text:"中国-重庆市-铜梁县",value:35880},
    {text:"中国-重庆市-荣昌县",value:35881},
    {text:"中国-重庆市-璧山县",value:35882},
    {text:"中国-重庆市-梁平县",value:35883},
    {text:"中国-重庆市-城口县",value:35884},
    {text:"中国-重庆市-丰都县",value:35885},
    {text:"中国-重庆市-垫江县",value:35886},
    {text:"中国-重庆市-武隆县",value:35887},
    {text:"中国-重庆市-忠县",value:35888},
    {text:"中国-重庆市-开县",value:35889},
    {text:"中国-重庆市-云阳县",value:35890},
    {text:"中国-重庆市-奉节县",value:35891},
    {text:"中国-重庆市-巫山县",value:35892},
    {text:"中国-重庆市-巫溪县",value:35893},
    {text:"中国-重庆市-石柱土家族自治县",value:35894},
    {text:"中国-重庆市-秀山土家族苗族自治县",value:35895},
    {text:"中国-重庆市-酉阳土家族苗族自治县",value:35896},
    {text:"中国-重庆市-彭水苗族土家族自治县",value:35897},
    {text:"中国-重庆市-万盛区",value:35898},
    {text:"中国-重庆市-双桥区",value:35899},
    {text:"中国-香港-东区",value:35900},
    {text:"中国-香港-中西区",value:35901},
    {text:"中国-香港-九龙城区",value:35902},
    {text:"中国-香港-元朗区",value:35903},
    {text:"中国-香港-北区",value:35904},
    {text:"中国-香港-南区",value:35905},
    {text:"中国-香港-大埔区",value:35906},
    {text:"中国-香港-屯门区",value:35907},
    {text:"中国-香港-沙田区",value:35908},
    {text:"中国-香港-油尖旺区",value:35909},
    {text:"中国-香港-深水埗区",value:35910},
    {text:"中国-香港-湾仔区",value:35911},
    {text:"中国-香港-离岛区",value:35912},
    {text:"中国-香港-荃湾区",value:35913},
    {text:"中国-香港-葵青区",value:35914},
    {text:"中国-香港-西贡区",value:35915},
    {text:"中国-香港-观塘区",value:35916},
    {text:"中国-香港-黄大仙区",value:35917},
    {text:"中国-澳门-凼仔",value:35918},
    {text:"中国-澳门-澳门半岛",value:35919},
    {text:"中国-澳门-路凼城",value:35920},
    {text:"中国-香港-路环",value:35921},
    {text:"境外-境外-境外",value:37005},
    {text:"中国-陕西省-安康市",value:60108},
    {text:"中国-陕西省-宝鸡市",value:60109},
    {text:"中国-陕西省-汉中市",value:60110},
    {text:"中国-陕西省-铜川市",value:60111},
    {text:"中国-陕西省-渭南市",value:60112},
    {text:"中国-陕西省-西安市",value:60113},
    {text:"中国-陕西省-咸阳市",value:60114},
    {text:"中国-陕西省-榆林市",value:60115},
    {text:"中国-陕西省-商洛市",value:60116},
    {text:"中国-陕西省-延安市",value:60117}
]